// hooks/useDevice.js
import { useEffect, useState } from "react";

const useDevice = () => {
	const [deviceType, setDeviceType] = useState("");
	const [screenHeight, setScreenHeight] = useState(0);

	useEffect(() => {
		const updateDeviceInfo = () => {
			const height =
				typeof window !== "undefined" ? window.screen.height : 0;
			setScreenHeight(height);

			const userAgent =
				typeof window !== "undefined" ? navigator.userAgent : "";

			if (/iPad/.test(userAgent)) {
				setDeviceType("iPad");
			} else if (/iPhone/.test(userAgent)) {
				setDeviceType("iPhone");
			} else if (/Android/.test(userAgent) && !/Mobile/.test(userAgent)) {
				setDeviceType("Android Tablet");
			} else if (/Android/.test(userAgent)) {
				setDeviceType("Android Phone");
			} else if (height < 768) {
				setDeviceType("Mobile");
			} else if (height < 1024) {
				setDeviceType("Tablet");
			} else {
				setDeviceType("Desktop");
			}
		};

		updateDeviceInfo();
		window.addEventListener("resize", updateDeviceInfo);

		return () => {
			window.removeEventListener("resize", updateDeviceInfo);
		};
	}, []);

	return { deviceType, screenHeight };
};

export default useDevice;
